import styled from 'styled-components';
import { key } from 'styled-theme';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  opacity: 0.8;
  background: white;
  border-radius: ${key('sizes.borderRadius')};
  padding: 38px;

  p {
    margin: 0;
  }

  h1 {
    margin: 0 0 20px;
  }

  ${media.lessThan('sm')`
    margin: -8px -8px 0;
    padding: 24px;
  `};

  ${media.moreThan('mdPlus')`
    max-width: 635px;
    text-align: left;

    h1 {
      font-size: ${key(`text.headings.h2.fontSize`)};
      line-height: ${key(`text.headings.h2.lineHeight`)};
    }

    p {
      font-size: 22px;
    }
  `};
`;
